<template>
  <li v-if="canViewVerticalNavMenuGroup(item)" class="nav-item has-sub  " :class="{
      'open': isOpen,
      'disabled': item.disabled,
      'sidebar-group-active': isActive,
    }">

    <b-link class="d-flex align-items-center" @click.prevent="() => updateGroupOpen(!isOpen)">
      
      <font-awesome-icon :icon="['fas',item.icon || 'fa-circle']" />
    
      <span class="menu-title text-truncate">{{ item.title }}</span>
      
      <b-badge v-if="item.tag" pill :variant="item.tagVariant || 'primary'" class="me-1 ms-auto">
        {{ item.tag }}
      </b-badge>

    </b-link>
    
    <b-collapse v-model="isOpen" class="menu-content" tag="ul">
      <component
        :is="resolveNavItemComponent(child)"
        v-for="child in item.children"
        :key="child.header || child.title"
        ref="groupChild"
        :item="child"
      />
    </b-collapse>

  </li>
</template>

<script setup>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@layouts/utils'
import { useUtils as useI18nUtils } from '@composables/i18n'
import { useUtils as useAclUtils } from '@composables/acl'


// Composition Function
import useVerticalNavMenuGroup from './useVerticalNavMenuGroup'

const props = defineProps({
  item:{
    type:Object,
    required:true
  }
});

const {
  isOpen,
  isActive,
  updateGroupOpen,
  updateIsActive,
} = useVerticalNavMenuGroup(props.item)


const { canViewVerticalNavMenuGroup } = useAclUtils()
</script>
